import { Component, Prop, h } from '@stencil/core';

/**
 * Footer Items provide an area for application or business specific links in the footer.
 */
@Component({
  tag: 'som-footer-item',
  styleUrl: 'som-footer-item.scss',
})
export class SomFooterItem {
  /**
   * This boolean shows the visual divider between items.
   */
  @Prop() showDivider: boolean = true;

  render() {
    return (
      <div role="listitem" class="footer-item">
        <slot />
        {this.showDivider ? 
          <div class="footer-item__divider"></div>
          : null
        }
      </div>
    );
  }
}
